'use client';

import { c as _c } from "react/compiler-runtime";
import { formatLongString } from '@morpho-org/morpho-ts';
import { Avatar, ButtonLink, ClipboardButton } from '@morpho-org/ui-v6/client';
import { Tag } from '@morpho-org/ui-v6/server';
import { Refresh } from '@repo/ui/icons';
import { abbreviateAddress } from '@repo/utils';
import { memo } from 'react';
import { useWeb3Context } from '@/contexts/Web3Context';
import { getPortfolioUrl } from '@/helpers/routing';
import { useViewedAccountAddress } from '@/hooks/useViewedAccountAddress';
const DashboardIdentityCard = () => {
  const $ = _c(25);
  const {
    account: t0
  } = useWeb3Context();
  const {
    address: connectedAddress,
    ens: connectedEns,
    ensImage: connectedEnsImage,
    isConnected
  } = t0;
  const {
    address: viewedAddress,
    isSelf
  } = useViewedAccountAddress();
  const displayEns = isSelf ? connectedEns : undefined;
  const displayEnsImage = isSelf ? connectedEnsImage : undefined;
  if (!viewedAddress) {
    return null;
  }
  let t1;
  if ($[0] !== displayEnsImage || $[1] !== viewedAddress) {
    t1 = <Avatar size="large" address={viewedAddress} ensUrl={displayEnsImage} className="max-lg:size-8 max-lg:p-0.5" />;
    $[0] = displayEnsImage;
    $[1] = viewedAddress;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== displayEns || $[4] !== viewedAddress) {
    t2 = displayEns ? formatLongString(displayEns, 20) : abbreviateAddress(viewedAddress);
    $[3] = displayEns;
    $[4] = viewedAddress;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <span className="text-title-sm max-lg:text-title-xs text-foreground">{t2}</span>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== viewedAddress) {
    t4 = <ClipboardButton toCopy={viewedAddress} toastMessage="Address copied to clipboard." tooltipMessage="Copy wallet address." size="sm" />;
    $[8] = viewedAddress;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== connectedAddress || $[11] !== isConnected || $[12] !== isSelf) {
    t5 = isConnected && connectedAddress && !isSelf && <ButtonLink mode="internal" href={getPortfolioUrl({
      userAddress: connectedAddress
    })} className="inline-flex items-center" buttonProps={{
      variant: "ghost",
      size: "sm",
      label: "Switch to your wallet",
      iconLeft: <Refresh />,
      className: "text-warning-foreground hover:text-warning-foreground active:text-warning-foreground"
    }} />;
    $[10] = connectedAddress;
    $[11] = isConnected;
    $[12] = isSelf;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== isConnected || $[15] !== isSelf) {
    t6 = isSelf && isConnected && <Tag variant="main" className="bg-success-foreground/24 text-success-foreground" startIcon={<span aria-hidden="true" className="bg-success-foreground size-1.5 shrink-0 rounded-full" />} label="Connected" />;
    $[14] = isConnected;
    $[15] = isSelf;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t3 || $[18] !== t4 || $[19] !== t5 || $[20] !== t6) {
    t7 = <div className="gap-xs flex items-center">{t3}{t4}{t5}{t6}</div>;
    $[17] = t3;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== t1 || $[23] !== t7) {
    t8 = <div data-testid="dashboard-identity-card" className="gap-sm flex items-center">{t1}{t7}</div>;
    $[22] = t1;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  return t8;
};
export default memo(DashboardIdentityCard);